import { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

import { endDeferredHydration, startDeferredHydration } from '../utils/editorPersistence'

const LOTTERY_PAGE_PATHS = new Set(Object.values(LotteryId).map((id) => `/${id.toLowerCase()}`))

// strips a locale prefix and a trailing slash: /es/powerball/ -> /powerball
const toPagePath = (pathname: string) =>
  pathname.replace(/^\/[a-z]{2}(?=\/)/, '').replace(/\/$/, '')

/*
 * Only the lottery page is server-rendered with the stores in their default state. Every other page,
 * such as the checkout redirect, must read the storage right away.
 */
export default defineNuxtPlugin((nuxtApp) => {
  if (!LOTTERY_PAGE_PATHS.has(toPagePath(window.location.pathname))) return

  startDeferredHydration()
  nuxtApp.hook('app:suspense:resolve', endDeferredHydration)
})
